import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=3f746bc6&scoped=true&"
import script from "./thankyou.vue?vue&type=script&lang=ts&"
export * from "./thankyou.vue?vue&type=script&lang=ts&"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=3f746bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f746bc6",
  null
  
)

export default component.exports